import React, { useState } from 'react';
import { Row, Col, Button, Form, Image, Card } from 'react-bootstrap';
import './AddContacts.css';
import { CreateContacts } from '../../../helpers/api';
// import { Card, Dropdown } from 'react-bootstrap';
const AddContacts: React.FC = () => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [group_name, setGroup] = useState('');
    const [file, setFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string | null>(null);

    const handleSave = async () => {
        if (!name || !phone) return alert('Name and phone are required.');
        if (!file) return alert('Profile picture is required.');

        try {
            await CreateContacts({
                name: name,
                mobile_no: phone,
                profile: file,
                group_name: group_name
            });

            setName('');
            setPhone('');
            setFile(null);
            setPreview(null);
        } catch (err) {
            alert('Error creating contact');
            console.error(err);
        }
    };

    const handleCancel = () => {
        setName('');
        setPhone('');
        setFile(null);
        setPreview(null);
    };

    const handleProfilePicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.files?.[0];
        if (selected) {
            setFile(selected);

            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result as string);
            reader.readAsDataURL(selected);
        }
    };

    return (
        <>
            <Card className="add-contact">
               <Card.Header className="bg-secondary d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 text-white">Add New Contact</h5>
                </Card.Header>
                <Card.Body>
                    <Row className="mb-3">
                        <Col xs={12} md={12}>
                            <Form.Group controlId="formProfilePic">
                                <Form.Label>Profile Picture</Form.Label>
                                <Form.Control type="file" accept="image/*" onChange={handleProfilePicChange} />
                            </Form.Group>
                            {preview && <Image src={preview} roundedCircle width={100} height={100} className="mt-2" />}
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group controlId="formName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group controlId="formPhone">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter phone number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={12}>
                            <Form.Group controlId="formGroup">
                                <Form.Label>Group Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Group Name"  
                                    value={group_name} 
                                    onChange={(e) => setGroup(e.target.value)}                         
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Button variant="primary" className="me-2" onClick={handleSave}>
                                Save
                            </Button>
                            <Button variant="secondary" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default AddContacts;
